import { useMemo } from "react"
import { useQuery } from "urql"

import "../graphql/queries"

import { GetTransferDocument, type Transfer, type TransferGetSuccess } from "@/graphql/codegen/graphql"

interface UseGetTransferReturn {
  transfer: Transfer | undefined
  isFetching: boolean
}

export const useGetTransfer = (transferId: string): UseGetTransferReturn => {
  const [{ data, fetching }] = useQuery({
    query: GetTransferDocument,
    variables: { input: { transferId } },
  })

  const output = data?.transfer.getById

  const transfer = useMemo((): Transfer | undefined => {
    if (output?.__typename === "TransferGetSuccess") {
      return (output as TransferGetSuccess).transfer as Transfer
    }

    return undefined
  }, [output])

  return { transfer, isFetching: fetching }
}
